export type RosaOneSaveSource = {
  transferUrl?: string;
  qrDataUrl?: string;
  qrCodeUrl?: string;
};

export const getRosaOneSaveUrl = ({
  transferUrl,
  qrDataUrl,
  qrCodeUrl,
}: RosaOneSaveSource): string | undefined =>
  transferUrl ? qrDataUrl : qrCodeUrl;
